<template>
    <div class="list-group-select">
        <div
            v-for="(listItem, listItemIndex) in listItems"
            :key="listItemIndex"
        >
            <div
                v-if="!listItem.grouped"
                class="list-group-select__group"
                :class="{'list-group-select__group_active': listItemActive !== null && listItemActive.group === listItem.group}"
                @click="onClickListItem(listItem)"
            >
              <i
                  v-if="isIconPrevMain && !listItem.grouped"
                  :class="`fa fa-chevron-circle-left`"
                  :style="{'color': `#a7b0bd`}"
                  @click.stop="onClickAddToCatalog(listItem)"
              >
              </i>
                {{listItem.group || ""}}
                <div>
                    <i
                        v-if="isIconDelete"
                        class="fa fa-trash"
                        :style="{'margin': '3px 10px 0 0','color': `#a7b0bd`}"
                        @click.stop="onClickRemoveGroup(listItem.group)"
                    >
                    </i>
                    <i
                        class="fa"
                        :class="{
                            'fa-angle-down': listItemActive !== null && listItemActive.group === listItem.group, 
                            'fa-angle-up': listItemActive === null || listItemActive.group !== listItem.group}"
                        :style="{'margin': '3px 10px 0 0','color': `#a7b0bd`}"
                    >
                    </i>
                </div>
            </div>
            <div v-if="listItemActive !== null && listItemActive.group === listItem.group">
                <div
                    v-for="(subListItem, subListItemIndex) in listItem.values"
                    :key="subListItemIndex"
                    class="list-group-select__sublist"
                >
                    <i
                        v-if="isIconPrev"
                        :class="`${iconPrevClass}`"
                        :style="{'color': `#a7b0bd`}"
                        @click.stop="onClickIconPrev(subListItem)"
                    >
                    </i>
                    {{subListItem}}
                </div>
            </div>
        </div>
    </div>
</template>

<script>
export default {
    name: 'ListGroupSelect',
    /**
     * входные данные компонента
     * @property {array} listItems - элементы списка
     * @property {object} listItemActive - активный элемент
     * @property {boolean} isIconPrev - условие показа иконки перед контентом в спике
     * @property {boolean} iconPrevClass - класс иконки перед контентом в списке
     */
    props: {
      listItems: {
        type: Array,
        default: () => ([])
      },
      listItemActive: {
        type: Object,
        default: () => (null)
      },
      isIconPrev: {
        type: Boolean,
        default: false
      },
      isIconDelete: {
        type: Boolean,
        default: false
      },
      isIconPrevMain: {
        type: Boolean,
        default: false
      },
      iconPrevClass: {
        type: String,
        default: ''
      }
    },
    methods: {
        /**
         * событие клика по элементу списка
         * @param {object} listItem - элемент списка
         */
        onClickListItem(listItem) {
            this.$emit('onClickListItem', listItem);
        },
        /**
         * событие клика по иконке удаления группы
         * @param {string} groupName - название группы
         */
        onClickRemoveGroup(groupName) {
            this.$emit('onClickRemoveGroup', groupName);
        },
        /**
         * событие клика по иконке удаления группы
         * @param {string} groupName - название группы
         */
        onClickAddToCatalog(groupName) {
            this.$emit('onClickAddToCatalog', groupName);
        },
        /**
         * событие клика по иконке в подсписке
         * @param {string} subListItem - элемент подсписка
         */
        onClickIconPrev(subListItem) {
            this.$emit('onClickIconPrev', subListItem);
        }
    }
}
</script>

<style lang="scss" scoped>
    .list-group-select__group {
        display: flex;
        justify-content: space-between;
        padding: 5px 0 5px 15px;
        cursor: pointer;
    }
    .list-group-select__sublist {
        margin: 0 0 0 15px;
        padding: 5px 0 5px 15px;
        cursor: pointer;
    }
    .list-group-select__group_active {
        background: #f0f0f0;
        border-radius: 30px;
    }
</style>